import { saveAs } from 'file-saver';

//Xml static elements
const macro_hedaer = '<?xml version="1.0" encoding="utf-8"?><MA xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://schemas.malighting.de/grandma2/xml/MA" xsi:schemaLocation="http://schemas.malighting.de/grandma2/xml/MA http://schemas.malighting.de/grandma2/xml/2.5.3/MA.xsd" major_vers="2" minor_vers="5" stream_vers="3"><Info datetime="2012-04-05T22:30:00" showfile="ffp" />';
const macro_end = '</Macro></MA>';
const timecode_header = '<?xml version="1.0" encoding="utf-8"?><MA xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://schemas.malighting.de/grandma2/xml/MA" xsi:schemaLocation="http://schemas.malighting.de/grandma2/xml/MA http://schemas.malighting.de/grandma2/xml/2.5.3/MA.xsd"major_vers="2" minor_vers="5" stream_vers="3"><Info datetime="2012-04-05T22:30:00" showfile="ffp" />';
const timecode_end = '</SubTrack></Track></Timecode></MA>';

async function writeTimecode(cues, seqNum, name) {
    return new Promise((resolve) => {

        var timecode_macro = timecode_header;

        timecode_macro += '<Timecode index="0" lenght="' + parseFloat(cues[cues.length - 1].time) * 30 + '" frame_format="25 FPS"><Track index="0" active="true" expanded="true"><Object name= "' + name + '"><No>27</No><No>1</No><No>1</No><No>7</No></Object><SubTrack index="0">';

        var index = 1;
        cues.forEach(cue => {
            var time = parseFloat(cue.time) * 30;
            timecode_macro += '<Event index="' + index++ + '" time="' + time + '" command="Goto" pressed="true" step="1"><Cue name=""><No>1</No><No>' + seqNum + '</No><No>' + parseCueNumber(cue.cue_number) + '</No></Cue></Event>';
        });

        timecode_macro += timecode_end;

        var blob = new Blob([timecode_macro], { type: "text/xml;charset=utf-8" });
        resolve({ 'timecode_macro': blob })
    })
}

async function writeCues(cues, seqNum, name) {
    return new Promise((resolve) => {
        var commands = [];

        commands.push('SetVar $seq = ' + seqNum + '/o')
        cues.forEach(cue => {
            var cuenumber = parseCueNumber(cue.cue_number);
            commands.push('Store Sequ $seq Cue ' + cuenumber + ' &quot;' + cue.cue_name + '&quot; Fade  OutFade /o')
            commands.push('Assign Seq $seq Cue ' + cuenumber + '  /info=&quot;&quot;')
        });

        commands.push('Label Seq $seq &quot;' + name + '&quot;')
        commands.push('Assign Seq $seq At Exec (input executer number)')
        commands.push('SetVar $importTimecode=("import timecode? y/n")')
        commands.push('[$importTimecode=="y"] SetVar $timecode = (input timecode number)')
        commands.push('[$importTimecode=="y"] Import &quot;' + name + '_timecode&quot; At Timecode $timecode')
        commands.push('[$importTimecode=="y"] Label Timecode $timecode &quot;' + name + '&quot; ')
        commands.push('[$importTimecode=="y"] Timecode $timecode Seq = &quot;' + name + '&quot; ')


        var blob = new Blob([generateCueMacro(commands, name)], { type: "text/xml;charset=utf-8" });
        resolve({ 'cue_macro': blob })
    });
}

function generateCueMacro(commands, name) {
    var cue_macro = macro_hedaer;
    cue_macro += '<Macro index="1" name="' + name + '">';

    commands.forEach((command, index) => {
       cue_macro += '<Macroline index = "' + index + '"><text>' + command + '</text></Macroline>';
    });

    cue_macro += macro_end;
    return cue_macro;
}

function parseCueNumber(input) {
    // eslint-disable-next-line
    // console.log(input.match(/\d+/));
    var regex = input.match(/\d+/);
    if (regex == null) {
        throw "cuenumber \"" + input + "\" does not contain any number";
    }
    return regex[0];
}

var ma2convert = async function(cues, seqNum = 500, name = 'default', makeTimecode) {
    // eslint-disable-next-line
    console.log(seqNum, name, makeTimecode)

    var safename = name.replaceAll(" ", "_")

    // eslint-disable-next-line
    console.log(seqNum, safename, makeTimecode)

    return new Promise((resolve, reject) => {
        if(makeTimecode) {
            writeTimecode(cues, seqNum, safename).then(res => {
                saveAs(res.timecode_macro, safename + "_timecode.xml");
                resolve();
            }).catch(err => {
                reject(Error(err))
            });
        }
        else {
            writeCues(cues, seqNum, safename).then(res => {
                saveAs(res.cue_macro, safename + "_cues.xml");
                resolve();
            }).catch(err => {
                reject(Error(err));
        })}
    });
};

export default ma2convert;